<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'help'" [businessName]="vm.businessName" [permitNo]="vm.permitNo">
</cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>
<div class="container" *ngIf="!vm.isOpening">
    <div class="row section-header">
        <div class="col pt-4">Help</div>
    </div>
    <div class="row pt-4">
        <div class="col-lg-6">
            <p>Need help with something? There is a chance you'll find the answer here.</p>
            <p>Use the <a routerLink="/app/contactus">contact form</a> to leave us a message regarding Hydrotrak, or
                simply call us on <b>(03) 1300 249 140</b> – Option 4</p>
        </div>
    </div>

    <div class="row section-subheader">
        <div class="col pt-2"><a href="javascript:void(0)" (click)="drow1=!drow1">Returning your Hydrotrak device?</a>
        </div>
    </div>
    <div class="row" *ngIf="drow1">
        <div class="col-lg-6">
            <br />
            <ul>
                <li class="pb-2">Unplug the device from the wiring</li>
                <li class="pb-2">Package your device carefully in a padded envelope/box with all parts included (device,
                    antennas and device holder) </li>
                <li class="pb-2">Send it to us at<br />
                    <strong>South East Water<br />
                        101 Wells Street Frankston 3199<br />
                        Attention: Hydrotrak Team</strong>
                </li>
                <li class="pb-2">Once we receive your device, we will send you a confirmation email, and the associated
                    vehicle will be removed from your account</li>
            </ul>
        </div>
    </div>

    <div class="row section-subheader">
        <div class="col pt-2"><a href="assets/HydrotrakConditionsofPermit.pdf" target="_blank">Terms and Conditions</a>
        </div>
    </div>
    <!-- <div class="row" *ngIf="drow2">
        <div class="col-8 pt-2 ">
            You can download Terms & Conditions by clicking on this <a href="assets/HydrotrakConditionsofPermit.pdf" target="_blank">link</a>
        </div>
    </div> -->
    <div class="row section-subheader">
        <div class="col pt-2"><a href="assets/HydrotrakPortalTC.pdf" target="_blank">Terms of Use</a>
        </div>
    </div>
    <div class="row pb-4">
    </div>
</div>